/**
 * DevExtreme (esm/__internal/ui/editor.js)
 * Version: 24.1.8
 * Build date: Mon Dec 16 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import Editor from "../../ui/editor/editor";
import Widget from "./widget";
const TypedEditor = Editor;
export default TypedEditor;
